/* tslint:disable */
/* eslint-disable */
export enum WorkMoveMontageplanBlockBehaviourEnum {
  None = 'NONE',
  Swap = 'SWAP',
  ShiftSource = 'SHIFT_SOURCE',
  ShiftTarget = 'SHIFT_TARGET',
  ShiftBoth = 'SHIFT_BOTH'
}
